import { UserPolices } from "constant";
import { useCallback } from "react";
import { useSelector } from "react-redux";

import { RootStateInterface } from "reducer";
import { AuthStateInterface } from "scenes/AuthPage/ducks";

const usePolicy = () => {
  const { jwtData } = useSelector<RootStateInterface, AuthStateInterface>(
    (state) => state.auth
  );

  const hasPolicy = useCallback(
    (policyId: UserPolices) => {
      return jwtData?.policies.includes(policyId);
    },
    [jwtData?.policies]
  );
  return { hasPolicy };
};

export default usePolicy;
